import { useTranslation } from 'react-i18next';

import { SewBillingCycleExport } from '@/backoffice/features/data-exports/sew-billing-cycle-export/sew-billing-cycle-export';
import { useLazySewInternalSapExportQuery } from '@/backoffice/redux/api/billing-backoffice/billing-backoffice-api';

export const SewInternalSapExport = () => {
  const { t } = useTranslation();
  const [getFile] = useLazySewInternalSapExportQuery();

  const fetchExport = async (billingCycleReferenceTs: number) => {
    const response = await getFile({ billingCycleReferenceTs }).unwrap();
    return response?.sewInternalSapExport;
  };

  return (
    <SewBillingCycleExport
      title={t('backoffice:sew.data_exports.internal_sap.title')}
      description={t('backoffice:sew.data_exports.internal_sap.description')}
      loaderText={t('backoffice:sew.data_exports.internal_sap.loader_text')}
      baseFileNamePrefix="sew_internal_sap_export"
      fetchExport={fetchExport}
    />
  );
};
